import * as React from 'react';
import { Button, Chip, Rating, Skeleton } from "@mui/material";
import { useEffect, useState } from 'react';
import { ApiRequest } from "GlobalFunctions";
import Box from "elements/Box";
import { Link } from 'react-router-dom';
import { CiStethoscope } from "react-icons/ci";
import { LiaUserEditSolid } from "react-icons/lia";
import { FaWhatsapp } from "react-icons/fa";
import StarRateRoundedIcon from '@mui/icons-material/StarRateRounded';

const defaultValues: any = {
    user_id: null,
    name: '',
    lastname: '',
    email: '',
    password: '',
    role_id: 1,
    phone: '',
    is_active: false,
    deleted: false,
    image: '',
    nurse_id: null,
    university_degree: '',
    service: '',
    price: '',
    region_id: '',
    region: '',
    locations: [],
    skills: [],
    locations_labels: [],
    skills_map: {},
    specialty_prices: {},
    about_me: '',
    badge_id: '',
    badge: '',
    average_rating: 0,
    whatsapp: '',
    commission_consent: false,
    commission_consent_date: '',
}

export default function AccountKinesiologists(props: any) {

    const [formValues, setFormValues] = useState<any>(defaultValues);

    const loadDetails = async () => {
        await ApiRequest({
            url: '/users/details',
            method: 'GET',
            setResponse: (response: any) => {
                setFormValues(response);
            }
        });
    }

    useEffect(() => {
        loadDetails();
    }, []);

    const skillsMap: Record<string, string> = formValues.skills_map || {};
    const specialtyPrices: Record<string, string> = formValues.specialty_prices || {};

    return (
        <div className="content">
            <div className='account_flex'>
                <div className='account_left'>
                    <Box>
                        <div className='section_flex'>
                            {/* Imagen de perfil */}
                            <div className="user_image">
                                {formValues.image ? (
                                    <img src={formValues.image} alt="Imagen de perfil" style={{ width: '150px', height: '150px' }} />
                                ):
                                (
                                    <Skeleton variant="rounded" width={200} height={200}/>
                                )}
                            </div>

                            <div className='account_right'>
                                <div className='info_column'>
                                    <h1 className='user_name'>{formValues.name} {formValues.lastname}</h1>
                                    <div className='items_row' style={{ gap: '6px', marginBottom: '4px' }}>
                                        {formValues.badge ? <Chip label={formValues.badge} /> : null}
                                    </div>
                                    <span className='user_subtitle'>{formValues.university_degree}</span>
                                    <span className='user_subtitle'>{formValues.region}</span>

                                    <Rating
                                        value={Number(formValues.average_rating) || 0}
                                        readOnly
                                        precision={0.5}
                                        icon={<StarRateRoundedIcon fontSize="inherit" />}
                                        emptyIcon={<StarRateRoundedIcon style={{ opacity: 0.55 }} fontSize="inherit" />}
                                    />


                                    <h3 className='service_title'>Servicio Ofrecido</h3>
                                    <div className='service_row'>
                                        <span className='service_label'>{formValues.service}</span>
                                        <span className='service_price'>{formValues.price}</span>
                                    </div>
                                </div>
                            </div>

                            <div>
                                <Button
                                    variant="contained"
                                    color="primary"
                                    component = {Link}
                                    to="/cuenta/editar"
                                    startIcon={<LiaUserEditSolid />}
                                >
                                    Editar
                                </Button>
                            </div>
                        </div>

                        <div>
                            <h2 className='titles'><CiStethoscope size={25} /> Acerca de mi</h2>
                            <p>{formValues.about_me}</p>
                        </div>

                        <div>
                            <h2 className='titles'>Comunas de servicio</h2>
                            <div className='items_row'>
                                {formValues.locations_labels?.length > 0 && (
                                    formValues.locations_labels.map((location: any, index: any) => (
                                        <Chip label={location} key={index} color="primary" sx={{ color: '#fff' }} />
                                    ))
                                )}
                            </div>
                        </div>

                        {Object.keys(skillsMap).length > 0 && (
                            <div>
                                <h2 className='titles'>Atenciones</h2>
                                <div style={{ display: 'flex', flexDirection: 'column', gap: 0 }}>
                                    {Object.entries(skillsMap).map(([skillId, label]) => {
                                        const price = specialtyPrices?.[skillId];
                                        return (
                                            <div key={skillId} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '10px 0', borderBottom: '1px solid #f1f5f9' }}>
                                                <span style={{ fontSize: 14, color: '#334155' }}>{label}</span>
                                                {price ? (
                                                    <span style={{ fontSize: 14, fontWeight: 700, color: '#005F6A' }}>
                                                        ${parseInt(price).toLocaleString('es-CL')}
                                                    </span>
                                                ) : (
                                                    <span style={{ fontSize: 13, color: '#94a3b8' }}>A convenir</span>
                                                )}
                                            </div>
                                        );
                                    })}
                                </div>
                            </div>
                        )}

                        {formValues.commission_consent && formValues.whatsapp && (
                        <div>
                            <h2 className='titles'>WhatsApp</h2>
                            <div className='items_row'>
                                <Button
                                    variant="contained"
                                    color="success"
                                    onClick={() => window.open(`https://wa.me/+56${formValues.whatsapp}`, '_blank')}
                                >
                                    <FaWhatsapp size={23} style={{ marginRight: '7px' }} />
                                    WhatsApp
                                </Button>
                            </div>
                        </div>
                        )}
                    </Box>

                </div>

            </div>
        </div>
    );
}
